import { Input, type InputVariant } from '@mantine/core';
import { useEffect, useState, type ReactElement } from 'react';

interface Props {
  value: number;
  onChange: (value: number) => void;
  variant?: InputVariant;
  currency: string;
}

const convertToNumber = (input: string) => {
  return Number(input.replace(/\D/g, ''));
};

export const PriceInput = (props: Props): ReactElement => {
  const { value, onChange, variant, currency } = props;
  const [inputValue, setInputValue] = useState<string>(
    String(value) + currency
  );

  useEffect(() => {
    setInputValue(String(value) + currency);
  }, [value]);

  const handleBlur = () => {
    setInputValue(String(value) + currency);
    onChange(convertToNumber(inputValue));
  };

  return (
    <Input
      value={inputValue}
      onChange={input => setInputValue(input.currentTarget.value)}
      onBlur={handleBlur}
      variant={variant}
    />
  );
};
